import { useQuery } from "@tanstack/react-query";
import { balanceSheetService } from "~/services/contabilidad/balanceSheetService";
import type { BalanceSheetFilters } from "~/types/contabilidad";

export const BALANCE_SHEET_QUERY_KEY = ["balance-sheet"];

export function useBalanceSheet(filters: BalanceSheetFilters) {
  return useQuery({
    queryKey: [...BALANCE_SHEET_QUERY_KEY, filters],
    queryFn: () => balanceSheetService.getBalanceSheet(filters),
    enabled:
      !!filters.dateFrom &&
      !!filters.dateTo &&
      !!filters.companyId &&
      !!filters.templateId,
  });
}
